import { Component, inject, OnInit, signal } from '@angular/core';
import { CoreModule, DialogComponent, IvvTitleComponent } from '@toevla-webapplications/core';
import { TranslateModule } from '@ngx-translate/core';
import { Offer } from '../../services/offers/offer.model';
import { RouterLink } from '@angular/router';
import { Observable, take } from 'rxjs';
import { FavoritesService } from '../../services/favorites/favorites.service';
import { AsyncPipe } from '@angular/common';
import { OfferCardComponent } from '../home/components/offer-card/offer-card.component';
import { HelpComponent } from '../../components/help/help.component';
import { ToastsService } from '../../services/toasts/toasts.service';

@Component({
    selector: 'ivva-favorites',
    templateUrl: './favorites.component.html',
    styleUrls: ['./favorites.component.scss'],
    imports: [IvvTitleComponent, TranslateModule, RouterLink, AsyncPipe, OfferCardComponent, CoreModule, HelpComponent, DialogComponent]
})
export class FavoritesComponent implements OnInit {
	favorites$: Observable<Offer[]>;
	shareLink = signal<string | null>(null);

	private readonly favoritesService = inject(FavoritesService);
	private readonly toastsService = inject(ToastsService);

	ngOnInit() {
		this.favorites$ = this.favoritesService.favorites$;
	}

	showShareLink() {
		this.favorites$.pipe(take(1)).subscribe((favorites) => {
			if (favorites.length > 5) {
				this.toastsService.error('TOAST.ERROR_SHARE_FAVORITES_TITLE', 'TOAST.ERROR_SHARE_FAVORITES_DESCRIPTION');
			} else {
				const ids = favorites.map((f) => f.id);
				const url = `https://${location.host}/share?ids=${ids.join(',')}`;
				this.shareLink.set(url);
			}
		});
	}

	copyLink() {
		const url = this.shareLink();

		if (url) {
			navigator.clipboard
				.writeText(url)
				.then(() => this.toastsService.success('TOAST.SUCCESS', 'TOAST.COPY_SHARE_LINK'))
				.catch(() => this.toastsService.error('TOAST.FAILED_TO_COPY_SHARE_LINK', 'TOAST.FAILED_TO_COPY_SHARE_LINK_MESSAGE'));
		}
	}
}
